module.exports = __webpack_public_path__ + "static/media/CenterBatchLabCountData.133e96aa.xlsx";